export default __webpack_public_path__ + "content/media/IcoTwitter.1b5b259a.svg";